import React, { useState } from "react"

import { Translate } from "../../Components/Translator"
import { EmbeddedDynamicsGetSettingAutoCreateCall, EmbeddedDynamicsSetSettingAutoCreateCall, EmbeddedDynamicsGetSettingAutoOpenMatch, 
    EmbeddedDynamicsSetSettingAutoOpenMatch, EmbeddedDynamicsGetSettingAutoCreateMatch, EmbeddedDynamicsSetSettingAutoCreateMatch,
    EmbeddedDynamicsGetSettingDefaultInboundCallSubject,EmbeddedDynamicsSetSettingDefaultInboundCallSubject,
    EmbeddedDynamicsGetSettingDefaultInboundCallPriority,EmbeddedDynamicsSetSettingDefaultInboundCallPriority,
    EmbeddedDynamicsGetSettingDefaultInboundCallDescription,EmbeddedDynamicsSetSettingDefaultInboundCallDescription,
    EmbeddedDynamicsGetSettingDefaultOutboundCallSubject,EmbeddedDynamicsSetSettingDefaultOutboundCallSubject,
    EmbeddedDynamicsGetSettingDefaultOutboundCallPriority,EmbeddedDynamicsSetSettingDefaultOutboundCallPriority,
    EmbeddedDynamicsGetSettingDefaultOutboundCallDescription,EmbeddedDynamicsSetSettingDefaultOutboundCallDescription } from "./EmbeddedDynamicsSupport.jsx"

const EmbeddedDynamicsSettings = (props) => {

    const [mRepainter, SetRepainter] = useState(0)

    const SetSettingAutoCreateCall = (value) => {
        EmbeddedDynamicsSetSettingAutoCreateCall(value)
        SetRepainter(mRepainter + 1)
    }

    const SetSettingAutoOpenMatch = (value) => {
        EmbeddedDynamicsSetSettingAutoOpenMatch(value)
        SetRepainter(mRepainter + 1)
    }

    const SetSettingAutoCreateMatch = (value) => {
        EmbeddedDynamicsSetSettingAutoCreateMatch(value)
        SetRepainter(mRepainter + 1)
    }

    const SetDefaultInboundCallSubject = (value) => {
        EmbeddedDynamicsSetSettingDefaultInboundCallSubject(value)
        SetRepainter(mRepainter + 1)
    }

    const SetDefaultInboundCallPriority = (value) => {
        EmbeddedDynamicsSetSettingDefaultInboundCallPriority(value)
        SetRepainter(mRepainter + 1)
    }

    const SetDefaultInboundCallDescription = (value) => {
        EmbeddedDynamicsSetSettingDefaultInboundCallDescription(value)
        SetRepainter(mRepainter + 1)
    }

    const SetDefaultOutboundCallSubject = (value) => {
        EmbeddedDynamicsSetSettingDefaultOutboundCallSubject(value)
        SetRepainter(mRepainter + 1)
    }

    const SetDefaultOutboundCallPriority = (value) => {
        EmbeddedDynamicsSetSettingDefaultOutboundCallPriority(value)
        SetRepainter(mRepainter + 1)
    }

    const SetDefaultOutboundCallDescription = (value) => {
        EmbeddedDynamicsSetSettingDefaultOutboundCallDescription(value)
        SetRepainter(mRepainter + 1)
    }

    const settingautocreatecall = EmbeddedDynamicsGetSettingAutoCreateCall()
    const settingautoopenmatch = EmbeddedDynamicsGetSettingAutoOpenMatch()
    const settingautocreatematch = EmbeddedDynamicsGetSettingAutoCreateMatch()    
    const settingdefaultinboundcallsubject = EmbeddedDynamicsGetSettingDefaultInboundCallSubject()
    const settingdefaultinboundcallpriority = EmbeddedDynamicsGetSettingDefaultInboundCallPriority()
    const settingdefaultinboundcalldescription = EmbeddedDynamicsGetSettingDefaultInboundCallDescription()
    const settingdefaultoutboundcallsubject = EmbeddedDynamicsGetSettingDefaultOutboundCallSubject()
    const settingdefaultoutboundcallpriority = EmbeddedDynamicsGetSettingDefaultOutboundCallPriority()
    const settingdefaultoutboundcalldescription = EmbeddedDynamicsGetSettingDefaultOutboundCallDescription()

    return (
        <>
            <tr className="usersettings" height="20"/>
            <tr className="foregroundlightasbackground">
                <td colSpan="2" align="center"><b>Zoho</b></td>
            </tr>
            
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Automatic actions")}</td>
                <td width="*" valign="center">
                    {Translate("What actions should be automatically performed?")}<br/>
                    <br/>
                    <b className="smalltext">{Translate("Create calls in Dynamics")}</b><br/>
                    <select name="Language" style={{ paddingLeft: "2px", width: "100%" }} onChange={(evt) => SetSettingAutoCreateCall(evt.target.value)} value={settingautocreatecall}>
                        <option value="no">{Translate("Never")}</option>
                        <option value="yes">{Translate("Always")}</option>
                    </select><br/> 
                    <br/>
                    <b className="smalltext">{Translate("Open single-matching Dynamics record")}</b><br/>
                    <select name="Language" style={{ paddingLeft: "2px", width: "100%" }} onChange={(evt) => SetSettingAutoOpenMatch(evt.target.value)} value={settingautoopenmatch}>
                        <option value="">{Translate("Never")}</option>
                        <option value="started">{Translate("When you receive the call")}</option>
                        <option value="answered">{Translate("When you answer the call")}</option>
                    </select><br/> 
                    <br/>  
                    <b className="smalltext">{Translate("Create and show new Dynamics item when no matches are found")}</b><br/>
                    <select name="Language" style={{ paddingLeft: "2px", width: "100%" }} onChange={(evt) => SetSettingAutoCreateMatch(evt.target.value)} value={settingautocreatematch}>
                        <option value="">{Translate("Never")}</option>
                        <option value="started_contact">{Translate("Create contact when you receive the call")}</option>
                        <option value="started_account">{Translate("Create account when you receive the call")}</option>
                        <option value="answered_contact">{Translate("Create contact when you answer the call")}</option>
                        <option value="answered_account">{Translate("Create account when you answer the call")}</option>
                    </select>
                    <br/>       
                </td>
            </tr>
            
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Inbound calls")}</td>
                <td width="*" valign="center">
                    {Translate("Default subject")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={settingdefaultinboundcallsubject} onChange={(evt) => SetDefaultInboundCallSubject(evt.target.value)}/><br/>
                    {Translate("Default priority")}<br/>
                    <select name="Language" style={{ paddingLeft: "2px", width: "100%" }} onChange={(evt) => SetDefaultInboundCallPriority(evt.target.value)} value={settingdefaultinboundcallpriority}>
                        <option value="0">{Translate("Low priority")}</option>
                        <option value="1">{Translate("Normal priority")}</option>
                        <option value="2">{Translate("High priority")}</option>
                    </select>
                    {Translate("Default description")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={settingdefaultinboundcalldescription} onChange={(evt) => SetDefaultInboundCallDescription(evt.target.value)}/><br/>

                    <span className="smallesttext">{Translate("Available callfields") + ": <callid> <number> <name> <extension> <ddi> <ddiname> <callstart> <calltime> <talktime>"}</span><br/>                                       
                </td>
            </tr>
            
            <tr className="usersettings">
                <td width="200" className="foregroundlightasbackground" valign="center">{Translate("Outbound calls")}</td>
                <td width="*" valign="center">
                    {Translate("Default subject")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={settingdefaultoutboundcallsubject} onChange={(evt) => SetDefaultOutboundCallSubject(evt.target.value)}/><br/>
                    {Translate("Default priority")}<br/>
                    <select name="Language" style={{ paddingLeft: "2px", width: "100%" }} onChange={(evt) => SetDefaultOutboundCallPriority(evt.target.value)} value={settingdefaultoutboundcallpriority}>
                        <option value="0">{Translate("Low priority")}</option>
                        <option value="1">{Translate("Normal priority")}</option>
                        <option value="2">{Translate("High priority")}</option>
                    </select>
                    {Translate("Default description")}<br/>
                    <textarea style={{ width: '100%', height: '100px', padding: '6px', marginTop: '0px' }} value={settingdefaultoutboundcalldescription} onChange={(evt) => SetDefaultOutboundCallDescription(evt.target.value)}/><br/>

                    <span className="smallesttext">{Translate("Available callfields") + ": <callid> <number> <name> <extension> <callstart> <calltime> <talktime>"}</span><br/>                                       
                </td>
            </tr>
        </>
    )
}

export default EmbeddedDynamicsSettings